"use client";

import { useEffect } from "react";

// Last-resort error boundary. Triggered when the root layout itself throws
// (the regular app/error.tsx does not run in that case). MUST render its own
// <html> and <body> because it replaces the root layout entirely.
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[GlobalError] Root-level client exception", {
      name: error.name,
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      url: typeof window !== "undefined" ? window.location.href : undefined,
      timestamp: new Date().toISOString(),
    });
  }, [error]);

  return (
    <html>
      <body />
    </html>
  );
}
